import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPremiumGraphic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 83,
	height: 54,
	viewBox: "0 0 83 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group 6259",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group 6255",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				opacity: .8,
				d: "M54.5805 13.8115L63.9505 16.7439L66.6437 18.6679L65.7704 15.5775V6.01733H70.4526V15.5775L69.5792 18.7388L72.1992 16.8856L81.5692 13.9478L83.0003 18.3463L73.6303 21.2732L70.4526 21.4259L72.988 23.1973L78.7745 30.9097L74.8924 33.684L69.1059 25.9007L68.0016 22.9683L66.886 25.9007L61.0995 33.6131L57.2907 30.9152L63.0772 23.2027L65.6972 21.3495L62.5194 21.1969L53.1494 18.2591L54.5805 13.7897V13.8115Z",
				fill: "url(#paint0_linear_3037_2236)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M14.4109 47.5252C5.80416 47.5252 0 41.1097 0 33.4658C0 25.8219 5.80416 19.4064 14.4109 19.4064C23.0177 19.4064 28.8218 25.7638 28.8218 33.4658C28.8218 41.1677 23.0177 47.5252 14.4109 47.5252ZM7.87708 33.4658C7.87708 36.8852 10.5636 39.8232 14.469 39.8232C18.3743 39.8232 21.0028 36.8852 21.0028 33.4658C21.0028 30.0464 18.3163 27.0502 14.469 27.0502C10.6216 27.0502 7.87708 30.0464 7.87708 33.4658ZM21.6164 59.8749L46.1017 18.9831L52.8179 22.4025L28.3326 63.3607L21.6164 59.8749ZM45.372 49.3013C45.372 41.5993 51.1762 35.2419 59.7829 35.2419C68.3896 35.2419 74.1938 41.5993 74.1938 49.3013C74.1938 57.0033 68.3896 63.3607 59.7829 63.3607C51.1762 63.3607 45.372 56.9452 45.372 49.3013ZM53.2491 49.3013C53.2491 52.7207 55.9356 55.6587 59.8409 55.6587C63.7463 55.6587 66.3748 52.7207 66.3748 49.3013C66.3748 45.8819 63.6883 42.8858 59.8409 42.8858C55.9936 42.8858 53.2491 45.8819 53.2491 49.3013Z",
				fill: "url(#paint1_linear_3037_2236)"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M37.6383 5.81295V-10H31.528V5.81295H16.0173V12.0467H31.528V27.8596H37.6383V12.0467H53.1489V5.81295H37.6383Z",
			fill: "#5F80F4"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3037_2236",
		x1: 46.0276,
		y1: -.109013,
		x2: 108.824,
		y2: 64.5302,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#FF96FF" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .06,
				stopColor: "#FF9DFF",
				stopOpacity: .93
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .41,
				stopColor: "#FFC6FF",
				stopOpacity: .54
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .7,
				stopColor: "#FFE4FF",
				stopOpacity: .25
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .9,
				stopColor: "#FFF7FF",
				stopOpacity: .07
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white",
				stopOpacity: 0
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint1_linear_3037_2236",
		x1: -1.56665e-8,
		y1: 68.5539,
		x2: 74.1941,
		y2: 68.5785,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B2C3FF" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E7EAF8"
		})]
	})] })]
});
export default SvgIconPremiumGraphic;
